<script setup lang="ts">
import { useI18nLocalize } from '@/i18n/i18nLocalize';
import { getTextVariant } from '@/utils/stringUtils';
import { useWorksheetComposable } from '@/components/modal/worksheet/useWorksheetComposable';

const props = defineProps<{
  flights: object[];
  lang: string;
  isAir?: boolean;
}>();

const { i18nLocale } = useI18nLocalize();
const { $t } = i18nLocale(props.lang);
const { getCabinType } = useWorksheetComposable();
const headers = [
  $t('client_copy.flight_number'),
  $t('common.from'),
  $t('common.to'),
  $t('client_copy.dep_date'),
  $t('client_copy.dep_time'),
  $t('client_copy.arrival_date'),
  $t('client_copy.arrival_time'),
  $t('common.via'),
  $t('common.class'),
  $t('common.cabin')
];

const handleCabinToArray = (cabin: string) => {
  if (cabin) {
    return cabin.split(', ');
  }
  return [];
};
</script>
<template>
  <table v-if="flights.length" class="table-child w-full flight">
    <thead>
      <tr>
        <th class="hidden" v-for="time in 10" :key="time"></th>
      </tr>
    </thead>
    <tbody>
      <tr class="background-grey text-sm text-center flight-header">
        <td v-for="header in headers" :key="header" class="text-sm" :class="{ 'w-3rem': header === $t('common.via') }">{{ header }}</td>
      </tr>
      <tr class="text-sm text-center flight-info" v-for="(flight, index) in flights" :key="index">
        <td class="text-sm no-wrap">
          {{ flight.operated || flight.flightNumber ? `${flight.operated} ${flight.flightNumber}` : '-' }}
        </td>
        <td class="text-sm">
          <span>{{ getTextVariant(lang, flight.gate, flight.gateFr) }}</span>
        </td>
        <td class="text-sm">
          <span>{{ getTextVariant(lang, flight.dest, flight.destFr) }}</span>
        </td>
        <td class="text-sm no-wrap">{{ flight.depDate ?? '-' }}</td>
        <td class="text-sm">{{ flight.depTime ?? '-' }}</td>
        <td class="text-sm no-wrap">{{ flight.arrDate ?? '-' }}</td>
        <td class="text-sm">{{ flight.arrTime ?? '-' }}</td>
        <td class="text-sm">{{ flight.via ?? '-' }}</td>
        <td class="text-sm">{{ flight.fClass ?? '-' }}</td>
        <td class="text-sm">{{ (isAir ? getCabinType(handleCabinToArray(flight.cabin)) : flight.cabin) ?? '-' }}</td>
      </tr>
    </tbody>
  </table>
</template>
